import React from 'react';

const ChartCard = ({ title, subtitle, action, children }) => {
  return (
    <section className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm h-full">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
          {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
      <div className="min-h-[260px]">{children}</div>
    </section>
  );
};

export default ChartCard;
